export default function isEuropeanCountry(countryCode) {
  const countryCodeList = [
    'EU',
    'GB',
    'IE',
    'FR',
    'DE',
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'GR',
    'HU',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'IS',
    'NO',
  ];
  return countryCodeList.includes(countryCode?.toUpperCase());
}
